import { errorToastMessage, successToastMessage } from "utils/errorToast.js";
import {
  LOADER_STATUS,
  SEARCH_STR,
  SELECTED,
  TABLE_DATA,
  TOTAL_PAGES,
  TOTAL_RECORDS,
  ITEM_LIST_DATA,
  EINV_ITEM_ERROR_DATA,
  GST_RES_TABLE_DATA,
  CHECKED_IRN,
  CHECKED_CANCEL,
  PROFILE_DATA,
  SELECTED_GSTIN,
  STATUS_CODE,
  STATUS_CODE_CANCEL,
  CHECKED_CANCEL_PAYLOAD,
  CHECKED_IRN_PAYLOAD,
  PART_B_ERROR,
  SUPPLIER_GSTIN_FILTER,
  RECEIPIENT_GSTIN_FILTER,
  SELECTED_FROM_DATE,
  SELECTED_TO_DATE,
  CHECKED_IRN_NOT_GENERATED_PAYLOAD,
  CHECKED_IRN_NOT_GENERATED,
  STATUS_CODE_NOT_GEN,
  SELECTED_ROW,
  BUYER_GSTIN_LIST,
  keyMap,
} from "./constants.js";
import { getLocalStorage } from "components/Helper/Helper.js";
import { Config } from "../../../Config.js";
import axios from "axios";
import moment from "moment";

export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}

export function setTableData(data) {
  return {
    type: TABLE_DATA,
    tableData: data,
  };
}
export function setTotalPages(pages) {
  return {
    type: TOTAL_PAGES,
    totalPages: pages,
  };
}

export function setTotalRecords(totalRecords) {
  return {
    type: TOTAL_RECORDS,
    totalRecords: totalRecords,
  };
}
export function setSearchStr(searchStr) {
  return {
    type: SEARCH_STR,
    searchStr: searchStr,
  };
}
export function setSelected(selected) {
  return {
    type: SELECTED,
    selected: selected,
  };
}

export function setItemListData(data) {
  return {
    type: ITEM_LIST_DATA,
    itemListData: data,
  };
}

export function setEinvItemErrorData(einvItemErrorData) {
  return {
    type: EINV_ITEM_ERROR_DATA,
    einvItemErrorData: einvItemErrorData,
  };
}

export function setGstResTableData(gstResTableData) {
  return {
    type: GST_RES_TABLE_DATA,
    gstResTableData: gstResTableData,
  };
}

export function setCheckedIrn() {
  return {
    type: CHECKED_IRN,
  };
}

export function setCheckedCancel() {
  return {
    type: CHECKED_CANCEL,
  };
}

export function setCheckedIrnNotGen() {
  return {
    type: CHECKED_IRN_NOT_GENERATED,
  };
}

export function setCheckedCancelPayload(checkedCancel) {
  return {
    type: CHECKED_CANCEL_PAYLOAD,
    checkedCancel: checkedCancel,
  };
}

export function setCheckedIrnPayload(checkedIrn) {
  return {
    type: CHECKED_IRN_PAYLOAD,
    checkedIrn: checkedIrn,
  };
}

export function setCheckedIrnNotGenPayload(checkedIrnNotGen) {
  return {
    type: CHECKED_IRN_NOT_GENERATED_PAYLOAD,
    checkedIrnNotGen: checkedIrnNotGen,
  };
}

export function setProfileData(profileData) {
  return {
    type: PROFILE_DATA,
    profileData: profileData,
  };
}

export function setSelectedGstin(selectedGstin) {
  return {
    type: SELECTED_GSTIN,
    selectedGstin: selectedGstin,
  };
}

export function setStatusCode(statusCode) {
  return {
    type: STATUS_CODE,
    statusCode: statusCode,
  };
}

export function setStatusCodeCancel(statusCodeCancel) {
  return {
    type: STATUS_CODE_CANCEL,
    statusCodeCancel: statusCodeCancel,
  };
}

export function setStatusCodeNotGen(statusCodeNotGen) {
  return {
    type: STATUS_CODE_NOT_GEN,
    statusCodeNotGen: statusCodeNotGen,
  };
}

export function setPartBError(partBError) {
  return {
    type: PART_B_ERROR,
    partBError: partBError,
  };
}

export function setSupplierGstinFilter(supplierGstinFilter) {
  return {
    type: SUPPLIER_GSTIN_FILTER,
    supplierGstinFilter: supplierGstinFilter,
  };
}
export function setReceipientGstinFilter(receipientGstinFilter) {
  return {
    type: RECEIPIENT_GSTIN_FILTER,
    receipientGstinFilter: receipientGstinFilter,
  };
}

export function setSelectedFromDate(selectedFromDate) {
  return {
    type: SELECTED_FROM_DATE,
    selectedFromDate: selectedFromDate,
  };
}

export function setSelectedToDate(selectedToDate) {
  return {
    type: SELECTED_TO_DATE,
    selectedToDate: selectedToDate,
  };
}

export function setSelectedRow(selectedRow) {
  return {
    type: SELECTED_ROW,
    selectedRow: selectedRow,
  };
}

export function setBuyerGstinList(buyerGstinList) {
  return {
    type: BUYER_GSTIN_LIST,
    buyerGstinList: buyerGstinList,
  };
}

export const getEinvoiceData = (
  search_st = "",
  current_page = 1,
  statusCode,
  supplierGstinFilter,
  receipientGstinFilter,
  selectedFromDate,
  selectedToDate
) => {
  const data = {
    search_st: search_st,
    current_page: current_page == "" ? 1 : current_page,
    statusCode: statusCode,
    supplierGstin: supplierGstinFilter,
    recipientGstin: receipientGstinFilter,
    fromDate: selectedFromDate,
    toDate: selectedToDate,
  };
  const URL_GET_EINVOICE_DATA = `${Config.url}gst/get_pass`;
  const headers = {
    token: getLocalStorage("loginDetails"),
  };
  return async (dispatch) => {
    dispatch(loader(true));
    try {
      const response = await axios({
        method: "post",
        url: URL_GET_EINVOICE_DATA,
        data: data,
        headers: headers,
      });

      if (response.data.error !== 1) {
        let pages =
          response.data && response.data.total_records
            ? response.data.total_records
            : 10;
        dispatch(setTotalPages(Math.ceil(pages / 50)));
        dispatch(setTotalRecords(response?.data?.total_records));
        const tableDataWithUniqueKey = response.data.responseJson?.map(
          (row, index) => ({
            ...row,
            uniqueKey: `${row.txn_id}_${index}`,
          })
        );
        // dispatch(setTableData(response.data.responseJson));
        dispatch(setTableData(tableDataWithUniqueKey));
        return tableDataWithUniqueKey;
        // return response.data.data;
      } else {
        dispatch(setTableData([]));
        return [];
      }
    } catch (error) {
      console.log(`Error in getEinvoiceData ${error}`);
      errorToastMessage("Error while fetching the Einvoice data");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const deleteRow = (txn_id) => {
  return async (dispatch) => {
    const data = { txn_id: Object.keys(txn_id).length === 1 ? txn_id : txn_id };
    const URL_DELETE_ROW = `${Config.url}gst/delete_record`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };

    dispatch(loader(true));
    try {
      const response = await axios({
        method: "post",
        url: URL_DELETE_ROW,
        data: data,
        headers: headers,
      });
      if (response.data.error != 1)
        successToastMessage(
          response.data.data || "Record deleted successfully"
        );
      else
        errorToastMessage(response.data.data || "Failed to delete the record");
    } catch (err) {
      console.log(`Error in deleteRow ${err}`);
      errorToastMessage("Error while deleting the record");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const sendEmail = (emailData, recipientEmail) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_SEND_EMAIL = `${Config.url}gst/ewb_send_email`;
    const headers = {
      token: getLocalStorage("loginDetails"),
      email: recipientEmail,
    };
    try {
      const response = await axios({
        method: "post",
        data: emailData,
        url: URL_SEND_EMAIL,
        headers: headers,
      });

      if (response.status == 200) successToastMessage(response.data.data);
      else errorToastMessage(response.data.data || "Error while sending email");
    } catch (error) {
      console.log(`Error in sendEmail: ${error}`);
      errorToastMessage("Error while  sending email");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const sendEmailEinv = (emailData, recipientEmail) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_SEND_EMAIL_EINV = `${Config.url}gst/send_email`;
    const headers = {
      token: getLocalStorage("loginDetails"),
      email: recipientEmail,
    };
    try {
      const response = await axios({
        method: "post",
        data: emailData,
        url: URL_SEND_EMAIL_EINV,
        headers: headers,
      });

      if (response.status == 200) successToastMessage(response.data.data);
      else errorToastMessage(response.data.data || "Error while sending email");
    } catch (error) {
      console.log(`Error in sendEmail: ${error}`);
      errorToastMessage("Error while sending email");
    } finally {
      dispatch(loader(false));
    }
  };
};
export const downloadPDF = (data) => {
  return async (dispatch) => {
    dispatch(loader(true));

    const URL_DOWNLOAD_PDF = `${Config.url}gst/download_ewaybill_pdf`;
    const headers = { token: getLocalStorage("loginDetails") };

    try {
      const response = await axios({
        method: "post",
        data: data,
        url: URL_DOWNLOAD_PDF,
        headers: headers,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${"ewb_"}${data.doc_No}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      successToastMessage("PDF downloaded successfully");
    } catch (error) {
      console.log(`Error in downloadPDF: ${error}`);
      errorToastMessage("Failed to download PDF");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const downloadPDFEinv = (data) => {
  return async (dispatch) => {
    dispatch(loader(true));

    const URL_DOWNLOAD_PDF_EINV = `${Config.url}gst/download_pdf`;
    const headers = { token: getLocalStorage("loginDetails") };

    try {
      const response = await axios({
        method: "post",
        data: data,
        url: URL_DOWNLOAD_PDF_EINV,
        headers: headers,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${"einv_"}${data?.doc_No}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      successToastMessage("PDF downloaded successfully");
    } catch (error) {
      console.log(`Error in downloadPDFEinv: ${error}`);
      errorToastMessage("Failed to downloadPDFEinv PDF");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getItemListData = (txnId, current_page) => {
  const data = { txn_id: txnId, current_page: current_page };
  const URL_ITEM_LIST_DATA = `${Config.url}gst/get_item_details`;

  return async (dispatch) => {
    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: URL_ITEM_LIST_DATA,
        data: data,
        timeout: 600000,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });
      if (response.data.error !== 1) {
        dispatch(setItemListData(response.data.data));
        return response.data.data;
      } else {
        dispatch(setItemListData([]));
        return [];
      }
    } catch (error) {
      console.log(`Error in getItemListData ${error}`);
    } finally {
      dispatch(loader(false));
    }
  };
};

export const deleteRowItemData = (txn_id, item_txn_id) => async (dispatch) => {
  const data = { txn_id: txn_id, item_txn_id: item_txn_id };
  const URL_DELETE_ROW_ITEM_DATA = `${Config.url}gst/delete_item_record`;
  dispatch(loader(true));
  try {
    const response = await axios({
      method: "post",
      data: data,
      url: URL_DELETE_ROW_ITEM_DATA,
      headers: { token: getLocalStorage("loginDetails") },
    });
    dispatch(loader(false));
    if (response.data.error !== 1) {
      successToastMessage("Record deleted successfully");
      return response.data.data;
    } else {
      errorToastMessage("Failed to delete the record");
      return response.data.data.info.msg;
    }
  } catch (error) {
    dispatch(loader(false));
    console.log(`Error in deleteRowItemData ${error}`);
    return false;
  }
};

export const onDownloadReport = (values) => {
  return async (dispatch) => {
    dispatch(loader(true));
    let fromDate = moment(new Date(values.fromDate)).format("DD/MM/YYYY");
    let toDate = moment(new Date(values.toDate)).format("DD/MM/YYYY");
    const data = {
      value: 4,
      txn_id: [],
      status: "",
      fromDate,
      toDate,
    };
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const URL_DOWNLOAD_REPORT = `${Config.url}gst/download_xlsx`;
    try {
      const response = await axios({
        method: "post",
        url: URL_DOWNLOAD_REPORT,
        data: data,
        headers: headers,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Invoice_generated_and_cancelled.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(url);

      successToastMessage("Excel downloaded successfully");
    } catch (err) {
      errorToastMessage("Failed to download excel");
      console.log(`Error in onDownloadReport ${err}`);
    } finally {
      dispatch(loader(false));
    }
  };
};

export const downloadExcel = (val, status) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const data = {
      value: 2,
      txn_id: val,
      status: status,
    };
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const URL_DOWNLOAD_REPORT = `${Config.url}gst/download_xlsx`;
    try {
      const response = await axios({
        method: "post",
        url: URL_DOWNLOAD_REPORT,
        data: data,
        headers: headers,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "pass_invoice_excel.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(url);

      successToastMessage("Excel downloaded successfully");
    } catch (err) {
      errorToastMessage("Failed to download excel");
      console.log(`Error in downloadExcel ${err}`);
    } finally {
      dispatch(loader(false));
    }
  };
};

export const onDownloadBulkPdf = (fromDate, toDate) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const data = {
      fromDate: fromDate,
      toDate: toDate,
    };
    const URL_DOWNLOAD_PDF_BULK = `${Config.url}gst/bulkPdfMail`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const successMsg =
      "Request submitted successfully. You will receive a mail shortly";
    const errorMsg = "Error while sending mail";
    try {
      const response = await axios({
        method: "post",
        url: URL_DOWNLOAD_PDF_BULK,
        data: data,
        headers: headers,
      });
      if (response.data?.error == 0) successToastMessage(successMsg);
      else errorToastMessage(response.data.data || errorMsg);
    } catch (err) {
      errorToastMessage("Error while sending mail");
      console.log(`Error in onDownloadBulkPdf ${err}`);
    } finally {
      dispatch(loader(false));
    }
  };
};

export const onGetIRN = (eligiblePayloads) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_GET_IRN = `${Config.url}gst/get_irn_status`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const successMsg = "Requested IRN fetched successfully";
    const errorMsg = "Requested IRN data is not available";
    const data = {
      invoices: eligiblePayloads,
    };
    try {
      const response = await axios({
        method: "post",
        url: URL_GET_IRN,
        data: data,
        headers: headers,
      });
      if (response?.data?.gst_response[0]?.error?.status_cd == "1")
        successToastMessage(successMsg);
      else errorToastMessage(errorMsg);
    } catch (err) {
      console.log(`Error in onGetIRN: ${err}`);
      errorToastMessage("Error while getting IRN");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const onSubmitInvoice = (val) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const data = {
      txn: val,
    };
    const URL_SUBMIT_INVOICE = `${Config.url}gst/submit_invoice`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const successMsg1 = "E-Invoice generated successfully";
    const successMsg2 = "E-Invoice and E-Way Bill generated successfully";
    const errorMsg = "E-Invoice generation failed";

    try {
      const response = await axios({
        method: "post",
        url: URL_SUBMIT_INVOICE,
        data: data,
        headers: headers,
      });
      if (
        response.data.error != 1 &&
        response.data?.data[0]?.error?.status_cd == "1"
      ) {
        if (response.data?.data[0]?.error?.data?.EwbNo == null) {
          successToastMessage(successMsg1);
        } else {
          successToastMessage(successMsg2);
        }
      } 
      else if( response.data.error != 1){
        successToastMessage(response.data?.msg || errorMsg);
      }
      else {
        errorToastMessage(errorMsg);
      }
    } catch (err) {
      console.log(`Error in onSubmitInvoice: ${err}`);
      errorToastMessage("Failed to generate IRN");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const onCancelIrn = (data) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_CANCEL_IRN = `${Config.url}gst/cancel_irn`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    try {
      const response = await axios({
        method: "post",
        url: URL_CANCEL_IRN,
        data: data,
        headers: headers,
      });
      if (response.data.error == 0) successToastMessage(response.data?.msg);
      else errorToastMessage(response.data?.data?.info?.msg);
    } catch (err) {
      console.log(`Errro in onCancelIrn: ${err}`);
      errorToastMessage("Error while cancelling the IRN");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getProfile = (value) => {
  return async (dispatch) => {
    // dispatch(loader(true));
    const data = {
      profileId: value,
    };
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const URL_GET_PROFILE = `${Config.url}gst/get_profile`;

    try {
      const response = await axios({
        method: "post",
        url: URL_GET_PROFILE,
        data: data,
        headers: headers,
      });
      if (response.data?.error != 1) {
        dispatch(setProfileData(response.data.profileInfo));
        return response.data?.profileInfo;
      } else {
        dispatch(setProfileData([]));
        return [];
      }
    } catch (err) {
      console.log(`Error in getProfile: ${err}`);
      errorToastMessage("Faile to fetch profile data");
    } finally {
      // dispatch(loader(false));
    }
  };
};

export const onGeneratePartB = (data) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_GENERATE_PART_B_EINV = `${Config.url}gst/generate-part-b`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const successMsg = "E-Way Bill generated successfully";

    try {
      const response = await axios({
        method: "post",
        url: URL_GENERATE_PART_B_EINV,
        data: data,
        headers: headers,
      });

      if (response.data?.error == 0) successToastMessage(successMsg);
      else dispatch(setPartBError(response?.data?.data[0]));
      // console.log("response?.data?.data[0]::", response?.data?.data[0]);
      return response.data?.error;
    } catch (err) {
      console.log(`Error in onGeneratePartB: ${err}`);
      errorToastMessage("Error while generating part B");
    } finally {
      dispatch(loader(false));
    }
  };
};

// export const downloadPdfNew = (
//   checkedItems,
//   selected,
//   supplierGstinFilter,
//   receipientGstinFilter,
//   selectedFromDate,
//   selectedToDate,
//   totalPages,
//   selectedRow
// ) => {
//   return async (dispatch) => {
//     dispatch(loader(true));

//     const URL_DOWNLOAD_PDF_NEW = `${Config.url}gst/download_multiple_pdfs`;
//     const headers = { token: getLocalStorage("loginDetails") };
//     let data = { sendEmail: false };

//     const isSinglePage = totalPages?.length === 1;
//     const isMultiPage = totalPages?.length > 1;
//     const hasSelected = selected?.length !== 0;
//     const noSelected = selected?.length === 0;

//     if (hasSelected) {
//       const transformed = selectedRow?.map((obj) => {
//         const result = {};
//         for (const [originalKey, newKey] of Object.entries(keyMap)) {
//           if (obj.hasOwnProperty(originalKey)) {
//             result[newKey] = obj[originalKey];
//           }
//         }
//         return result;
//       });

//       // console.log("transformed::", transformed);
//       data.txn_ids = transformed;
//       data.ewayBill = checkedItems?.ewayBill;
//     } else if (noSelected) {
//       data.supplierGstin = supplierGstinFilter;
//       data.recipientGstin = receipientGstinFilter;
//       data.fromDate = selectedFromDate;
//       data.toDate = selectedToDate;
//       data.ewayBill = checkedItems?.ewayBill;
//     }
//     try {
//       const response = await axios({
//         method: "post",
//         data: {data},
//         url: URL_DOWNLOAD_PDF_NEW,
//         headers: headers,
//         responseType: "blob",
//       });

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       // if (!checkedItems.ewayBill) {
//       //   link.setAttribute("download", "Einvoice.pdf");
//       // } else {
//       //   link.setAttribute("download", "EinvEwayBill.zip");
//       // }
//       const now = new Date();
// const pad = (n) => n.toString().padStart(2, '0');
// const timestamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
// const filename = `${timestamp}.zip`;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       URL.revokeObjectURL(url);
//       successToastMessage("Download successful");
//     } catch (error) {
//       console.log(`Error in downloadPdfNew: ${error}`);
//       errorToastMessage("Failed to download");
//     } finally {
//       dispatch(loader(false));
//     }
//   };
// };


export const downloadPdfNew = (
  checkedItems,
  selected,
  supplierGstinFilter,
  receipientGstinFilter,
  selectedFromDate,
  selectedToDate,
  totalPages,
  selectedRow
) => {
  return async (dispatch) => {
    dispatch(loader(true));

    const URL_DOWNLOAD_PDF_NEW = `${Config.url}gst/download_multiple_pdfs`;
    const headers = { token: getLocalStorage("loginDetails") };
    let data = { sendEmail: false };

    const hasSelected = selected?.length !== 0;
    const noSelected = selected?.length === 0;

    if (hasSelected) {
      const transformed = selectedRow?.map((obj) => {
        const result = {};
        for (const [originalKey, newKey] of Object.entries(keyMap)) {
          if (obj.hasOwnProperty(originalKey)) {
            result[newKey] = obj[originalKey];
          }
        }
        return result;
      });

      data.txn_ids = transformed;
      data.ewayBill = checkedItems?.ewayBill;
    } else if (noSelected) {
      data.supplierGstin = supplierGstinFilter;
      data.recipientGstin = receipientGstinFilter;
      data.fromDate = selectedFromDate;
      data.toDate = selectedToDate;
      data.ewayBill = checkedItems?.ewayBill;
    }

    try {
      const response = await axios({
        method: "post",
        data: { data },
        url: URL_DOWNLOAD_PDF_NEW,
        headers,
      });

      if (response?.data?.error === 0) {
        successToastMessage(
          response?.data?.data ||
            "File generation is in progress. Download link will be available in the Download Center once ready."
        );
      } else {
        errorToastMessage(response?.data?.data || "Failed to download");
      }
    } catch (error) {
      console.log(`Error in downloadPdfNew: ${error}`);
      errorToastMessage("Failed to download");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const sendMailPdfNew = (
  emails,
  selected,
  supplierGstinFilter,
  receipientGstinFilter,
  selectedFromDate,
  selectedToDate,
  totalPages,
  selectedRow,
  checkedItems,
  totalRecords
) => {
  return async (dispatch) => {
    dispatch(loader(true));
    // console.log('totalRecords::',totalRecords)
    let data = { sendEmail: true, emails };
    
    const isSinglePage = totalPages?.length === 1;
    const isMultiPage = totalPages?.length > 1;
    const hasSelected = selected?.length !== 0;
    const noSelected = selected?.length === 0;
    // console.log('totalRecords::',totalRecords)
    // console.log('selected::',selected)
    // if (hasSelected) {
    if(totalRecords <= 50 ){
      
    // console.log('totalRecords <= 50::',totalRecords <= 50)
        const transformed = selectedRow?.map((obj) => {
        const result = {};
        for (const [originalKey, newKey] of Object.entries(keyMap)) {
          if (obj.hasOwnProperty(originalKey)) {
            result[newKey] = obj[originalKey];
          }
        }
        return result;
      });

      // console.log("transformed::", transformed);
      data.txn_ids = transformed;
      data.ewayBill = checkedItems?.ewayBill;
    } 
    // else if (noSelected) {
       else if(totalRecords > 50 && selected?.length == 50) {  
        // console.log('totalRecords > 50 && selected == 50::',totalRecords > 50 && selected == 50)
      data.supplierGstin = supplierGstinFilter;
      data.recipientGstin = receipientGstinFilter;
      data.fromDate = selectedFromDate;
      data.toDate = selectedToDate;
      data.ewayBill = checkedItems?.ewayBill;
    }
    else if(totalRecords > 50 && selected?.length < 50){
      // console.log('(totalRecords > 50 && selected < 50::',totalRecords > 50 && selected < 50)
        const transformed = selectedRow?.map((obj) => {
        const result = {};
        for (const [originalKey, newKey] of Object.entries(keyMap)) {
          if (obj.hasOwnProperty(originalKey)) {
            result[newKey] = obj[originalKey];
          }
        }
        return result;
      });

      // console.log("transformed::", transformed);
      data.txn_ids = transformed;
      data.ewayBill = checkedItems?.ewayBill;
    }
    else{
      console.log('selected')
    }
    const URL_SEND_MAIL_PDF_NEW = `${Config.url}gst/download_multiple_pdfs`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const successMsg =
      "Request submitted successfully. You will receive a mail shortly";
    const errorMsg = "Error while sending mail";
    try {
      const response = await axios({
        method: "post",
        url: URL_SEND_MAIL_PDF_NEW,
        data: {data},
        headers: headers,
      });
      if (response.data?.error == 0) successToastMessage(successMsg);
      else errorToastMessage(response.data.data || errorMsg);
    } catch (err) {
      errorToastMessage(errorMsg);
      console.log(`Error in sendMailPdfNew: ${err}`);
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getBuyerGstinList = () => {
  return async (dispatch) => {
    // dispatch(loader(true));

    const URL_GET_BUYER_GSTIN_LIST = `${Config.url}gst/get_recipient_gstin_list`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };

    try {
      const response = await axios({
        method: "post",
        url: URL_GET_BUYER_GSTIN_LIST,
        headers: headers,
      });
      if (response.data?.error === 0) {
        // successToastMessage(successMsg)
        // console.log("response.data.data::", response.data.data);
        dispatch(setBuyerGstinList(response.data.data));
      } else {
        dispatch(setBuyerGstinList([]));
        errorToastMessage(
          response.data.error || "Error while getting buyer gstins list"
        );
      }
    } catch (err) {
      errorToastMessage(`Error in getBuyerGstinList: ${err}`);
      console.log(`Error in getBuyerGstinList: ${err}`);
    } finally {
      // dispatch(loader(false));
    }
  };
};
